import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const defaultStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "26.5rem",
  maxWidth: "100%",
  overflowY: "auto",
  borderRadius: ".75rem",
  bgcolor: "background.paper",
  boxShadow: 24,
  py: 2,
  px: 0
};

interface ApplicationFilterModalProps {
  title?: string;
  content?: string;
  open: boolean;
  handleClose: () => void;
  handleOpen?: () => void;
  children: React.ReactNode;
  sx?: any;
}

const ApplicationFilterModal: React.FC<ApplicationFilterModalProps> = ({
  title,
  content,
  open,
  handleClose,
  children,
  sx
}) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="application-filter-modal-title"
      aria-describedby="application-filter-modal-description"
      disableAutoFocus
    >
      <Box sx={{ ...defaultStyle, ...sx }}>
        {title && (
          <p
            id="application-filter-modal-title"
            className="body-m px-4 pb-3 font-bold"
          >
            {title}
          </p>
        )}
        {content && (
          <p
            id="application-filter-modal-description"
            className="body-xs font-regular px-4 pb-2"
          >
            {content}
          </p>
        )}
        {children}
      </Box>
    </Modal>
  );
};

export default ApplicationFilterModal;
